import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { API } from "@/lib/api";
import { useMe } from "@/context/MeContext";

const Box = ({ children }) => <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-32 text-center">{children}</div>;

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const { me, refresh } = useMe();
  const isMp = params.get("provider") === "mp";
  const sid = isMp ? params.get("order_id") : params.get("session_id");
  const paymentId = params.get("payment_id");

  useEffect(() => {
    let tries = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = isMp
          ? await axios.get(`${API}/payments/mp/status/${sid}`, { params: paymentId && paymentId !== "null" ? { payment_id: paymentId } : {} })
          : await axios.get(`${API}/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch {}
      if (++tries < 15 && !stop) setTimeout(poll, 2000); else setState("timeout");
    };
    if (sid) poll(); else setState("failed");
    return () => { stop = true; };
  }, [sid, refresh, isMp, paymentId]);

  return (
    <Box>
      <div data-testid="payment-status" data-state={state}>
        {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-[#FF4500]" /><h1 className="mt-6 font-heading text-3xl font-bold text-white">Confirmando tu pago...</h1></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" /><h1 className="mt-6 font-heading text-3xl font-bold text-white">¡Pago confirmado!</h1><p className="mt-3 text-slate-400">{me?.is_pro ? "Tu Plan Pro está activo. " : ""}Tu saldo ahora es de {me?.credits ?? "…"} créditos.</p></>}
        {state === "failed" && <><XCircle className="mx-auto h-12 w-12 text-red-400" /><h1 className="mt-6 font-heading text-3xl font-bold text-white">El pago no se completó</h1></>}
        {state === "timeout" && <><h1 className="font-heading text-3xl font-bold text-white">Seguimos esperando la confirmación</h1><p className="mt-3 text-slate-400">Revisa tu panel en unos minutos.</p></>}
      </div>
      <Link to="/panel" data-testid="payment-go-panel" className="mt-10 rounded-full bg-[#FF4500] px-6 py-3 font-semibold text-white">Ir a mi panel</Link>
    </Box>
  );
}

export function PaymentCancel() {
  return (
    <Box>
      <h1 data-testid="payment-cancelled" className="font-heading text-3xl font-bold text-white">Pago cancelado</h1>
      <p className="mt-3 text-slate-400">No se realizó ningún cargo.</p>
      <Link to="/creditos" className="mt-10 rounded-full bg-white px-6 py-3 font-semibold text-black">Volver a créditos</Link>
    </Box>
  );
}
